import React from 'react';

export default class Parallax extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      style: {
        container: {
          ...props.style,
          backgroundColor: '#000',
          backgroundImage: '',
          backgroundAttachment: 'fixed',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          position: 'relative',
        },
        content: {
          color: this.props.color,
          maxWidth: '1200px',
          width: '85%',
          margin: 'auto',
          padding: '40px 0',
        },
      },
    };
  }

  componentWillMount() {
    const image = this.props.image;
    const container = this.state.style.container;
    container.backgroundImage = `url(${image})`;
    this.setState({ container });
  }

  render() {
    return (
      <div style={this.state.style.container}>
        <div style={this.state.style.content}>
          { this.props.children }
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/section/index.js